import { render } from "./AppsSelected.vue?vue&type=template&id=3509acd6&scoped=true"
import script from "./AppsSelected.vue?vue&type=script&lang=js"
export * from "./AppsSelected.vue?vue&type=script&lang=js"

import "./AppsSelected.vue?vue&type=style&index=0&id=3509acd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3509acd6"]])

export default __exports__